export default __webpack_public_path__ + "static/media/group-bg.a5ffb308.png";